// 统一请求路径前缀在commmon/axios.js中修改
import {
  getRequest,
  postRequest,
  postRequestLogin,
  putRequest,
  putNoToken,
  getRequestWithNoToken,
} from "../assets/js/api";

// 注册账户
export const _register = (params) => {
  return postRequestLogin("/api-system/users/register", params);
};

// 登录
export const _login = (params) => {
  return postRequestLogin("/api-auth/authority/login/smsCode", params);
};

// 获取验证码
export const _getCode = (params) => {
  return postRequestLogin("/api-system/users/getCodeC", params);
};

// 校验验证码
export const _getCheckCode = (params) => {
  return postRequestLogin("/api-system/users/getCheckCode", params);
};

// 忘记密码
export const _forgetPassword = (params) => {
  return postRequestLogin("/api-system/users/forgetPassword", params);
};

// 查询用户信息
export const _getUserInfo = (params) => {
  return getRequestWithNoToken("/api-system/users/getUserInfo", params);
};

// 查询用户是否签署了知情同意书
export const _queryInformedConsent = (params) => {
  return getRequestWithNoToken(
    "/api-customer-c/psyInformedConsent/queryUserInformedConsent",
    params
  );
};

// 查询最新的知情同意书
export const _contentLast = (modelType, version) => {
  return getRequestWithNoToken(
    `/api-system/psyInformedConsent/content/last/${modelType}/${version}`
  );
};

// 查询知情同意书配置接口
export const _consentConfig = (modelType) => {
  return getRequestWithNoToken(
    `/api-system/psyInformedConsent/consentConfig/${modelType}`
  );
};

// 保存知情同意书
export const _informedConsentUserRelation = (params) => {
  return postRequestLogin(
    "/api-customer-c/psyInformedConsent/informedConsentUserRelation",
    params
  );
};

// 跟据token获取用户信息
export const _getUser = (params) => {
  return getRequest("/api-system/users/getUser", params);
};

// 获取康复师字典接口
export const _getRehabilitationTrainerDict = (itemKey) => {
  return getRequest(`/api-institution/getRehabilitationTrainerDict/${itemKey}`);
};
// 机构
export const _getOrganization = (params) => {
  return postRequest(
    "/api-institution/organization/name/notAuth/search",
    params
  );
};
// 文件上传接口
export const _upload = (params) => {
  return postRequest("/api-file/file/upload", params);
};
// 康复师新增
export const _add = (params) => {
  return postRequest("/api-institution/request/rehabilitationTrainer", params);
};
// 康复师详情
export const _detail = (params) => {
  return getRequest("/api-institution/request/detail/getInfoByUserId", params);
};
// 康复师修改
export const _update = (params) => {
  return postRequest(
    "/api-institution/request/update/rehabilitationTrainer",
    params
  );
};
// 与儿童的关系
export const _relation = (params) => {
  return getRequest("/api-common/dict-item/invoke/list", params);
};
// 家长建立孩子健康档案
export const _addOrEdit = (params) => {
  return postRequest("/api-customer/psy_student/c/healthArchives", params);
};
// 儿童建档详情
export const _childDetail = (params) => {
  return postRequest(
    "/api-customer/psy_student/c/getHealthArchivesByLoginUser",
    params
  );
};
//
export const _getIllness = (params) => {
  return postRequest("/api-common/dict-item/list", params);
};
